import { render } from "./MultiplePictureChoice.vue?vue&type=template&id=a858eb8a&scoped=true&ts=true"
import script from "./MultiplePictureChoice.vue?vue&type=script&lang=ts"
export * from "./MultiplePictureChoice.vue?vue&type=script&lang=ts"

import _style_0 from "./MultiplePictureChoice.vue?vue&type=style&index=0&id=a858eb8a&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-a858eb8a"]])

export default __exports__